import { useIntl } from 'react-intl';
import { ButtonUI, Prompt } from 'sonata-react-components';

type Props = {
  onClose: () => void;
  onConfirm: () => void;
};

export function CancelPrompt({ onClose, onConfirm }: Props) {
  const { formatMessage } = useIntl();

  return (
    <Prompt className="cancelPrompt" closePrompt={onClose} width="713px">
      <Prompt.Title>
        {formatMessage({
          defaultMessage: 'Cancel POI Upload?',
          id: 'poiImporter.prompt.cancelTitle'
        })}
      </Prompt.Title>
      <Prompt.Description>
        {formatMessage({
          defaultMessage: `Are you sure you want to cancel? All progress will be lost and no POIs will be added.`,
          id: 'poiImporter.prompt.cancelDescription'
        })}
      </Prompt.Description>
      <Prompt.Buttons position="centered">
        <ButtonUI
          onClick={onClose}
          shape="squareRounded"
          text={formatMessage({
            defaultMessage: 'Dismiss',
            id: 'common.cancel'
          })}
          type="secondary"
        />
        <ButtonUI
          onClick={onConfirm}
          shape="squareRounded"
          text={formatMessage({
            defaultMessage: 'Confirm',
            id: 'common.confirm'
          })}
          type="primary"
        />
      </Prompt.Buttons>
    </Prompt>
  );
}
